<template>
  <div class="therapistAndLocationsList">
      <v-container fluid>
          <div v-if="!therapistsItems || !therapistsItems.length">
              Er zijn geen beschikbare therapeuten gevonden.
          </div>
          <div v-else >
              <p>Selecteer de gewenste therapeut*</p>
              <div v-for="therapist in therapistsItems" :key="therapist.id">
                  <v-list-item-content fluid>
                      <TherapistItem v-on:fromTherapistItem="onTherapistSelect"
                                     v-bind:therapist="therapist" />
                  </v-list-item-content>
              </div>
          </div>
      </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import TherapistItem from "./TherapistItem";
import { services } from "../_services";
import { mapActions, mapState } from "vuex";

export default {
  props: {
    formModel: Object,
    resetData: Boolean,
    selected: Boolean,
  },
  components: {
    TherapistItem,
  },
  computed: {
    AppointmentTypeChange() {
        return this.formModel.appointmentType;
    },
    categoryIdChange() {
        return this.formModel.categoryId;
    },
    ...mapState({
      appBar: (state) => state.appBar,
    }),
  },
  data: function () {
    return {
      therapistsItems: [],
    };
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear",
      showAlert: "alert/error",
      selectComp: "appBar/selectComp",
      updateFormModel: "appBar/updateFormModel",
    }),
    onTherapistSelect(value) {
      var therapist = this.therapistsItems.find((x) => x.id == value);
      var $this = this;

      this.updateFormModel({
        formModel: {
          id: 3,
          title: therapist.title,
          locatieId: therapist.locatieId,
          therapeutId: parseInt(therapist.therapeutId, 10),
          therapeutName: therapist.therapeutName,
          therapeutDescription: therapist.description,
          firstSlot: therapist.firstSlot,
          locatieName: therapist.location,
          selected: true,
        },
        callback: function () {
          $this.selectComp({
            id: 4,
            type: "select",
            resetData: true,
            emptySelection: false,
          });
        },
      });
    },
    clearSelection() {
      if (this.resetData == true) {
        this.updateFormModel({
          formModel: {
            id: 3,
            title: "",
            locatieId: 0,
            therapeutId: 0,
            therapeutName: null,
            therapeutDescription: null,
            firstSlot: null,
            selected: false,
          },
        });
      }
    },
  },
    watch: {
        AppointmentTypeChange() {
            this.updateFormModel({
                formModel: {
                    id: 3,
                    title: "",
                    locatieId: 0,
                    therapeutId: 0,
                    therapeutName: null,
                    therapeutDescription: null,
                    firstSlot: null,
                    selected: false,
                },
            });
        },  
        categoryIdChange() {
          if (this.formModel.categoryId != null) {
            services.fetchTherapeut(this.formModel).then(
              (data) => {
                this.therapistsItems = null;
                this.therapistsItems = data;
                if (this.therapistsItems.length == 1) {
                    var selectedTherapist = this.therapistsItems[0];
                    this.onTherapistSelect(selectedTherapist.id);                                                   
                }
              },
              (error) => {
                this.showAlert(error);
              }
            );
          } else {
            this.updateFormModel({
              formModel: {
                id: 3,
                title: "",
                locatieId: 0,
                therapeutId: 0,
                therapeutName: null,
                therapeutDescription: null,
                firstSlot: null,
                selected: false,
              },
            });
          }
      },
      resetData() {
          this.clearSelection();
      },
  },
};
</script>